import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import StreamSchedule from '@/components/schedule/List';
import UserService from '@/services/UserService';
import VideoPlayer from '@/components/widget/VideoPlayer';
import LivestreamService from '@/services/LivestreamService';
import { bus } from '@/eventBus';
export default {
  name: 'Live',
  components: {
    StreamSchedule,
    VideoPlayer
  },
  props: {
    id: {
      type: [Number, String],
      default: 0
    }
  },
  data: () => {
    return {
      viewedInterval: 30,
      updateInterval: 30,
      livestream: {
        id: 0,
        data: {},
        show: false
      },
      info: {
        loading: false,
        error: false,
        message: 'Loading Video Info'
      },
      loadingMessage: 'Loading Video',
      network_id: 0,
      organization_id: 0,
      provider: null,
      videoOptions: {
        disablePictureInPicture: true,
        controls: true,
        autoplay: false,
        liveui: true,
        html5: {
          vhs: {}
        },
        sources: []
      }
    };
  },
  created: function () {
    this.init();
  },
  methods: {
    init: function () {
      UserService.getNetworkInfo().then(response => {
        if (response) {
          this.network_id = response.id;
          this.organization_id = response.organization_id;
        }
      });
      if (+this.id > 0) {
        this.fetch();
      }
    },
    fetch: function () {
      bus.$emit('videoLoading');
      this.info.loading = true;
      LivestreamService.init(+this.id).then(response => {
        this.livestream.data = response.data;
        this.provider = this.livestream.data.provider;
        this.info.loading = false;
        this.videoOptions.sources = [];
        this.videoOptions.sources.push({
          src: atob(this.livestream.data.playlist_link),
          type: 'application/x-mpegURL'
        });
      }).catch(error => {
        this.$aim.error(error.response);
        this.info.error = true;
        this.info.loading = false;
        bus.$emit('videoError');
      });
    }
  }
};